import React from 'react';

export const IconChevronRight = () => (
    <svg viewBox="0 0 24 24">
        <path d="M9 18l6-6l-6-6"/>
    </svg>
);

export const IconChevronLeft = () => (
    <svg viewBox="0 0 24 24">
        <path d="M15 18l-6-6l6-6"/>
    </svg>
);
